import React, { useEffect, useState } from "react";
import axiosClient from "../../../axios-client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import Navbar from "../Navbar";
import SideBar from "../SideBar";
import { useNavigate } from "react-router-dom";

const UploadCompanies = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
  const [modalMessage, setModalMessage] = useState(""); // Modal message
  const navigate = useNavigate();

  // Handle file selection
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // Handle file upload
  const handleUpload = async (event) => {
    event.preventDefault();
    if (!file) {
      setMessage("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setUploading(true);
      // Simulate the 2-second delay for loading animation
      setTimeout(async () => {
        try {
          const response = await axiosClient.post(
            "company/upload/details",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          setMessage(`File uploaded successfully: ${response}`);
          setModalMessage(` ${response.data}`);
          console.log(response);

          setModalOpen(true); // Open the modal on success
        } catch (error) {
          console.error("Upload error:", error);
          setMessage("Failed to upload the file. Please try again.");
        } finally {
          setUploading(false);
        }
      }, 2000); // Delay for 2 seconds before making the upload request
    } catch (error) {
      console.error("Upload error:", error);
      setMessage("Failed to upload the file. Please try again.");
      setUploading(false);
    }
  };
  useEffect(() => {
    const adminToken = localStorage.getItem("Admin_Token");
    if (!adminToken) {
      navigate("/admin/login");
    }
  }, [navigate]);

  return (
    <>
      <SideBar />
      {/* <Navbar /> */}
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6 pl-[19rem]">
        {/* Upload Section */}
        <div className="w-full max-w-4xl">
          <h1 className="text-2xl font-bold mb-6 text-center">
            Upload Company Details
          </h1>

          <form
            onSubmit={handleUpload}
            className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-8"
          >
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="file"
              >
                Upload the companies details
              </label>
              <input
                type="file"
                id="file"
                accept=".xlsx, .xls"
                onChange={handleFileChange}
                className="border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="flex justify-between items-center">
              <button
                type="submit"
                disabled={uploading}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none"
              >
                {uploading ? "Uploading..." : "Upload"}
              </button>
              <a
                href="/sampleFile/CompanyProfilesData.xlsx"
                download="CompanyProfilesData.xlsx"
                className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none"
              >
                <FontAwesomeIcon icon={faFileDownload} className="mr-2" />
                Sample Report
              </a>
            </div>
          </form>
        </div>

        {/* Modal for Success Message */}
        {modalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
            <div className="bg-white p-6 rounded shadow-lg">
              <h2 className="text-lg font-bold text-center">{modalMessage}</h2>
              <button
                onClick={() => setModalOpen(false)}
                className="mt-4 bg-blue-500 text-white font-bold py-2 px-4 rounded"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UploadCompanies;
